export enum UserTypeEnum {
  Producer = 0,
  Captioner = 1,
  AiWriter = 2,
  Connector = 3,
  Unknown = 4,
}

export type UserType =
  | UserTypeEnum.Producer
  | UserTypeEnum.Captioner
  | UserTypeEnum.AiWriter
  | UserTypeEnum.Connector
  | UserTypeEnum.Unknown;
